import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { useGlobalState } from '../../../stateProvider/StateProvider';
import PageBreak from '../../../layout/PageBreak';
import FormSetting from '../../../layout/FormSetting';
import HamQuest from '../../../api/HamQuestGiver';
import Input from '../../../forms/Input';
import Select from '../../../forms/Select';
import { HSOptions } from '../../../../constants/HSOptions';
import Checkbox from '../../../forms/Checkbox';
import Button from '../../../forms/Button';
import Table from '../../../table/Table';
import { generateId } from '../../../utility/functions';
import GetState from '../../../GetState';
import Loading from '../../../Loading';
import Page from '../../../layout/Page';
import Form from '../../../forms/Form';
import ManagementRow from '../../../table/ManagementRow';
import PhoneNumberInput from '../../../forms/formComponents/PhoneNumberInput';
import ModalFactory from '../../../Modal';
import AutoSelectAndUpgrade from '../../../forms/formComponents/AutoSelectAndUpgrade';
import Audit from '../Audit';

const LoyaltyMember = ({ userData, ...props }) => {
    const types = {
        LP: 'LicensePlate',
        RF: 'RFID',
        App: 'AppId',
    };

    const { loyaltyMemberId } = useParams();

    const [member, refreshMember] = GetState(QuestRoute.loyaltyUser.member(loyaltyMemberId));

    if (!member) return <Loading page />;

    const passMaxUses = [...HSOptions.expressPass.maxUsePeriod];
    const receiptMode = [...HSOptions.expressPass.receiptMode];

    const deleteMedia = (media) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: 'Are you sure?',
                body: 'Are you sure you want to delete this Media ID?',
                type: 'warning',
            },
            promise: {
                title: 'Removing Media ID',
                callback: () => HamQuest.delete(QuestRoute.user.mediaID(member.customerId, media.mediaId))
            },
            confirmed: {
                title: 'Media Deleted',
                type: 'success',
            },
            finally: () => refreshMember()
        })
    }

    const editMedia = (media) => {
        // console.log(media)
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Editing Media`,
            body: (
                <Form
                    inputs={{
                        mediaId: media.mediaId,
                        status: media.status,
                    }}
                    onSubmit={e => (
                        HamQuest.put(QuestRoute.user.mediaID(member.customerId, media.mediaId), { ...e })
                            .then(() => {
                                ModalFactory.close(id);
                                refreshMember()
                            })
                    )}
                >
                    {({ values }) => (
                        <>
                            <Input
                                name='mediaId'
                                label={'Media ID'}
                                sanitize={e => {
                                    if (values.mediaType !== types.LP) return e;
                                    return e.replace(/./g, (char) => char.toUpperCase())
                                }}
                                maxLength={values.mediaType === types.LP ? 8 : 100}
                                disabled
                                required
                            />
                            <Select
                                name='status'
                                label='Status'
                                options={HSOptions.expressPass.status}
                                required
                            />
                        </>
                    )}
                </Form>
            )
        })
    }

    const addNewMedia = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `New Media`,
            body: (
                <Form
                    inputs={{
                        mediaType: 'RFID',
                        status: 'Active',
                        mediaId: '',
                    }}
                    onSubmit={e => (
                        HamQuest.post(QuestRoute.user.mediaIDs(member.customerId), { ...e })
                            .then(() => {
                                ModalFactory.close(id);
                                refreshMember()
                            })
                    )}
                >
                    {({ values }) => (
                        <>
                            <Select
                                name='mediaType'
                                label='Media Type'
                                options={[{ label: 'RFID', value: 'RFID' }]}
                                required
                            />
                            <Select
                                name='tagType'
                                label='Tag Type'
                                options={HSOptions.user.media.tags}
                                required
                            />
                            <Input
                                label='RFID'
                                value={values.tagType === 'Hamilton' ? '1026...' : 'AAA...'}
                                disabled
                                required
                            />
                            <Select
                                label='Status'
                                name='status'
                                options={HSOptions.expressPass.status}
                                required
                            />
                            <Input
                                name='mediaId'
                                label='Media ID'
                                sanitize={e => e.replace(/\D/g, '')}
                                maxLength={values.mediaType === types.LP ? 8 : 100}
                                required
                            />
                        </>
                    )}
                </Form >
            )
        })
    }




    return (
        <Page
            title={member.contact.firstName + ' ' + member.contact.lastName}
            HSpage='loyalty_user'
            tabs
        >
            <PageBreak tab='Settings'>
                <FormSetting
                    label='Settings'
                    inputs={{ ...member }}
                    onSubmit={e => HamQuest.put(QuestRoute.loyaltyUser.member(loyaltyMemberId), { ...e })}
                    text='Update'
                    editable
                >
                    {({ values }) => (
                        <>
                            <Select
                                label='Member Status'
                                name='status'
                                options={HSOptions.expressPass.status}
                                required
                            />
                            <Select
                                label='Loyalty Type'
                                name='loyaltyType'
                                getOptions={QuestRoute.products.loyaltyTypes}
                                required
                                disabled
                            />
                            <Select
                                label='Award'
                                name='awardName'
                                getOptions={QuestRoute.expressPass.signupAwards + HamQuest.queryString({ loyaltyType: values.loyaltyType, loyaltyAccountId: member.loyaltyAccountId })}
                                required
                            />
                            <Select
                                label='Max Use Period'
                                name='passMaxUsePeriod'
                                options={passMaxUses}
                                required
                            />
                            <Input
                                label='Package Price'
                                name='packagePrice'
                                type='price'
                                disabled
                                required
                            />
                            <Checkbox
                                label='Use Custom Price'
                                name='useCustomPrice'
                            />
                            <Input
                                label='Custom Price'
                                name='customPrice'
                                type='price'
                                disable={!values.useCustomPrice}
                            />
                            <Input
                                label='Pass Max Uses'
                                name='passMaxUses'
                                type='number'
                                disable={values.passMaxUsePeriod === member.passMaxUsePeriod}
                                required
                            />
                            <Checkbox
                                label='Use Default Pass Reuse Time'
                                name='useDefaultPassReuseTime'
                            />
                            <Input
                                label='Pass Reuse Inhibit Time (min)'
                                name='passReuseInhibitTime'
                                type='numbers'
                                disabled={values.useDefaultPassReuseTime}
                                required
                            />

                            <Select
                                label='Receipt Mode'
                                name='receiptMode'
                                options={receiptMode}
                                required
                            />

                            <AutoSelectAndUpgrade />
                        </>
                    )}
                </FormSetting>

                <FormSetting
                    label='Contact Info'
                    inputs={{ ...member.contact }}
                    onSubmit={e => HamQuest.put(QuestRoute.loyaltyUser.member(loyaltyMemberId), { ...e })}
                    text='Update'
                    editable
                >
                    {({ values }) => (
                        <>
                            <Input
                                label='First Name'
                                name='firstName'
                                required
                            />
                            <Input
                                label='Last Name'
                                name='lastName'
                                required
                            />
                            <PhoneNumberInput
                                name='phone'
                            />
                            <Input
                                label='Email'
                                name='email'
                                type='email'
                                required
                            />
                        </>
                    )}
                </FormSetting>
            </PageBreak>

            {/* <Audit tab='Audit Log' customerId={member.customerId} /> */}

            <Table
                tab='Media'
                config={{
                    data: member.media ?? [],
                    controls: [<Button onClick={addNewMedia}>Add New Media</Button>],
                    label: 'Member Media',
                    disableHeaderSearch: true,
                    headers: [
                        {
                            label: 'Type',
                            propKey: 'mediaType',
                            options: true,
                        }, {
                            label: 'ID',
                            propKey: 'mediaId',
                        }, {
                            label: 'status',
                            propKey: 'status',
                        },
                    ],
                    renderFormat: (e) => (
                        <ManagementRow
                            key={generateId()}
                            controls={[
                                <Button onClick={() => editMedia(e)} key={generateId()}>Edit</Button>,
                                <Button onClick={() => deleteMedia(e)} key={generateId()}>Delete</Button>
                            ]}
                        >
                            <td>{e.mediaType}</td>
                            <td>{e.mediaId}</td>
                            <td>{e.status}</td>
                        </ManagementRow>
                    )
                }}
            />

        </Page>
    );
}

export default LoyaltyMember;
